'use client';

import Decimal from 'decimal.js';
import useSWR from 'swr';

import { fetchApiClient } from '@/api/fetchers/fetchApiClient';
import { Rate } from '@/api/trading/types';

export function useConvert({
  from,
  to,
  baseAmount,
  fallbackData,
}: {
  from: string;
  to: string;
  baseAmount: number | null;
  fallbackData?: Rate;
}): {
  rate: number | null;
  amount: number | null;
  error: any;
  isLoading: boolean;
} {
  const { data, error, isLoading } = useSWR<Rate | null>(
    from && to ? { url: '/v2/convert', from, to } : null,
    (key) =>
      fetchApiClient<Rate>(key.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          from: key.from.toUpperCase(),
          to: key.to.toUpperCase(),
        }),
      }),
    {
      fallbackData,
    },
  );

  return {
    rate: data?.rate || null,
    amount:
      typeof data?.rate === 'number' && typeof baseAmount === 'number'
        ? Decimal.mul(data.rate, baseAmount).toNumber()
        : null,
    error,
    isLoading,
  };
}
